"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var discountListStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette;
    return ({
        container: {
            borderBottom: "1px solid " + palette.primaryDisabled.main,
            padding: '4px 0',
        },
    });
}, { name: 'Summary_DiscountList' });
exports.default = discountListStyles;
